import eventManager from 'common/services/-RFC.eventManager';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _serviceDependencies = ['$scope', 'Util'];

class ConfirmLogin {

    constructor($scope, Util) {

        eventManager.broadcast('modal.closeBtn:hide');

        $scope.brandName = CWCONFIG.partnerConfig.name;
        $scope.confirm = () => {

            Mixpanel.send('ConnectWeb Login Confirmation Modal Click', {
                'Button Label': 'Confirm',
            });
            eventManager.broadcast('confirm-login:true');
            Util.closeModal();

        };
        $scope.cancel = () => {

            Mixpanel.send('ConnectWeb Login Confirmation Modal Click', {
                'Button Label': 'Cancel',
            });
            Util.closeModal();

        };

    }

}
_serviceDependencies.push(ConfirmLogin);

angular.module('controllers')
    .controller('ConfirmLogin', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/confirm-login/confirm-login.js